import { defineElement, html, TemplateElement } from '@webtides/element-js';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import InputEvents from '../events/InputEvents';
import styles from './_checkbox-control.css';

export default class CheckboxControl extends TemplateElement {
    constructor() {
        super({ shadowRender: false, autoUpdate: false, styles: [styles] });
    }

    properties() {
        return {
            name: 'name',
            value: '',
            label: 'label',
            checked: false,
            required: false,
            help: false,
        };
    }

    // prettier-ignore
    template() {
        return html`
            <div class="checkbox-control">
                <label class="flex items-center hover:cursor-pointer">
                    <input ref="input" type="checkbox" id="input-${this.name}" aria-describedby="${this.name}-help" name="${this.name}" value="${this.value}" ?checked="${this.checked === true}" ?required="${this.required === true}" >
                    <div class="selected-indicator h-6 w-6 bg-white border-2 p-2px">
                        <svg-icon name="check" class="checked w-full h-full"></svg-icon>
                    </div>
                    <span class="ml-2">${unsafeHTML(this.label)}</span>
                </label>
                ${this.help ? `<span id="${this.name}-help" class="form-help-text">${this.help}</span>` : ''}
            </div>
        `;
    }

    events() {
        return {
            input: {
                change: e => {
                    e.stopPropagation();
                    this.checked = this.$refs.input.checked;
                    this.dispatch(InputEvents.INPUT_CHANGE, this.checked, true);
                },
            },
        };
    }

    watch() {
        return Object.assign(super.watch(), {
            checked: () => {
                if (this.checked) {
                    this.classList.add('is-checked');
                } else {
                    this.classList.remove('is-checked');
                }
            },
        });
    }
}

defineElement('checkbox-control', CheckboxControl);
